/**
 * Loops through all our reative background elements and initiates the
 * 
 * @export
 * @class ReativeBackgrounds
 */
import { forEach } from '../../helpers/utilities';

import { ReactiveBackground } from './reactive-background';

export class ReactiveBackgrounds {

    constructor() {
        const backgrounds = document.querySelectorAll('[data-reative-bg]');
        if(backgrounds) {

            forEach(backgrounds, ({}, container: Element) => {
                const background = <HTMLElement>container.querySelector('[data-reative-bg-elem]');
                if(background) {
                    const strength = Number(container.getAttribute('data-reactive-bg-strength'));
                    new ReactiveBackground(container, background, strength > 0 ? strength : undefined); 
                }
            });

        }
    }
}
